module.exports = __webpack_public_path__ + "img/downloadres.8eb039fc.svg";